import React from 'react';

export default function getOption(params) {
    const { icon, text, subText, value } = params;

    return {
        label: (
            <div className="col-xs-12">
                <div className="col-xs-12 single-type">
                    <div className="col-xs-12 col-md-4 text-center">
                        <i className="material-icons">{icon}</i>
                    </div>
                    <div className="col-xs-12 col-md-8">
                        <h5>{text}</h5>
                        {subText}
                    </div>
                </div>
            </div>
        ),
        value
    };
}



// WEBPACK FOOTER //
// ./src/components/fields/bigRadioOption/index.jsx